import type { EligibilityCoupon } from '@/domains/loyalty/modules/CouponEligibility/interfaces/EligibilityCoupon';

export interface EligibilityCouponState {
  eligibilityCoupon?: EligibilityCoupon;
  error?: string | null;
}

export const initialState: EligibilityCouponState = {};
